import axios from 'axios';

import AuthService from '../../state/auth.service';
import endpoints from '../endpoints';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    getTemplateIdByName(name) {
        return axios
            .get(endpoints.TEMPLATES_BASE + `/${name}`, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },
    getInitialTemplatesByYears(yearsArray) {
        return axios
            .get(endpoints.TEMPLATES_BASE + `/getInitialYears`, {
                headers: getHeaders(),
                params: {
                    years: JSON.stringify(yearsArray),
                },
            })
            .then(response => {
                return response.data;
            });
    },
    getLatestInitialTemplates() {
        return axios
            .get(endpoints.TEMPLATES_BASE + `/getLatestInitialTemplates`, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },
};
